import { useState } from 'react';
import { siteFaqs } from '@/mocks/cases';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading eyebrow="FAQ" title="常见问题" desc="关于核实方式、化名处理与异议流程，这里集中回答。" />
        <div className="divide-y divide-background-300 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {siteFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-base font-medium text-foreground-950">{faq.q}</span>
                  <i
                    className={`shrink-0 text-lg text-primary-600 ${
                      isOpen ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {isOpen && <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}